import { render, staticRenderFns } from "./BillInfo.vue?vue&type=template&id=145f902b&scoped=true&"
import script from "./BillInfo.vue?vue&type=script&lang=js&"
export * from "./BillInfo.vue?vue&type=script&lang=js&"
import style0 from "./BillInfo.vue?vue&type=style&index=0&id=145f902b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145f902b",
  null
  
)

export default component.exports